<template>
	<Panel :title="trans('users.labels.accessibility_settings')">
		<!-- <form @submit.prevent="onFormSubmit"> -->
		<UiForm id="update-form-accessibility" @submit.prevent="onFormSubmit">
			<RadioInput
				v-model="form.display_type" type="radio" :required="true" :model-value="form.display_type"
				:label="trans('users.labels.select_entry_pref')" name="accessibility-select-sliders-numbers" class="mb-4"
				:options="[{ id: 'slider', title: trans('global.phrases.slider_desc') }, { id: 'numeric', title: trans('global.phrases.numeric_desc') }]"
				@update:model-value="updateFormSelectEntry"/>
			<br>
			<UiButton type="submit" :label="trans('global.buttons.update')" @click="onFormSubmit" />
		</UiForm>
	</Panel>
</template>

<script>
	import AuthService from "@/services/AuthService";
	import { trans } from "@/helpers/i18n";
	import { defineComponent, reactive, onMounted } from "vue";
	import { getResponseError } from "@/helpers/api";
	import { useAuthStore } from "@/stores/auth";
	import { useAlertStore } from "@/stores";
	import UiButton from "@/views/components/input/UiButton.vue";
	import RadioInput from "@/views/components/input/RadioInput.vue";
	import UiForm from "@/views/components/UiForm.vue";
	import Panel from "@/views/components/Panel";

	export default defineComponent({
		components: {
			Panel,
			UiButton,
			RadioInput,
			UiForm
		},

		setup: function () {

			const authService = new AuthService();
			const alertStore = useAlertStore();
			const authStore = useAuthStore();
			const form = reactive({
				first_name: null,
				last_name: null,
				middle_name: null,
				email: null,
				type: null,
				display_type: null
			});

			onMounted(() => {
				if (!authStore.user) {
					return;
				}
				form.first_name = authStore.user.first_name;
				form.last_name = authStore.user.last_name;
				form.middle_name = authStore.user.middle_name;
				form.email = authStore.user.email;
				form.type = authStore.user.type;
				form.display_type = authStore.user.display_type;
			});

			function updateFormSelectEntry (value) {
				form.display_type = value.id;
			}

			function onFormSubmit () {
				authService.updateUser(form)
					.then(() => authStore.getCurrentUser())
					.then((response) => (alertStore.success(trans("global.phrases.profile_updated"))))
					.catch((error) => (alertStore.error(getResponseError(error))));
			}

			return {
				onFormSubmit,
				form,
				trans,
				updateFormSelectEntry
			};
		}
	});
</script>
